import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {IUserField} from "../../../utils/interfaces/Estimate/IUserField";
import useApi from "../../../utils/custom-hooks/api-hooks/useApi";
import {useApp} from "../../../utils/global-contexts/AppContext";


const useApiUpdateEstimateUserField = (): UseMutationResult<IUserField, AxiosError, {
    id: number | undefined;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {putEncoded, put} = useApi()
    const {selectedEstimate} = useApp()

    async function doMutation(
        pk: number | undefined,
        data: any): Promise<IUserField> {
        try {
            const response = await put(`/usersfields/${pk}`, data);
            return response.data.data as IUserField;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IUserField, AxiosError, {
        id: number | undefined;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doMutation(id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetEstimate', selectedEstimate?.id]});
        },
    });
};


export default useApiUpdateEstimateUserField;
